import React, { createContext, useState } from 'react';

export const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const [feedback, setFeedback] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [thumbs, setThumbs] = useState({thumbsUp: false, thumbsDown: false });
  const [startTime, setStartTime]= useState(null);
  const [endTime, setEndTime]=useState(null);

  return (
  <FeedbackContext.Provider value={{ feedback, setFeedback, showPopup, setShowPopup, thumbs, setThumbs,startTime,setStartTime,endTime,setEndTime}}>
      {children}
    </FeedbackContext.Provider>
  );
};
